/**
 * @file  Financial
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React from 'react';
import {Navigation} from '@yunying/crow';
// eslint-disable-next-line import/extensions
import routes from '~/route.config';

import './index.less';


function Financial(props) {
    const {children} = props;

    return (
        <div className="financial-container">
            <Navigation dataSource={
                routes[0].subRoutes.find(item => item.name === 'financial').subRoutes.map((item, index) => ({
                    title: item.title,
                    key: index,
                    path: `/financial/${item.path}`
                }))
            }
            />
            {children}
        </div>
    );
}

export default Financial;
